import React from 'react'
import classNames from 'classnames/bind'

import CategoryLink from './categoryLink'

import styles from './categoriesMenu.module.css'

const TopLevelMenu = ({ item }) => {
  let cx = classNames.bind(styles)
  const hasChildren = item.children.length > 0
  const isNew = item.isNew
  const linkClassName = cx(styles.link, {
    link: hasChildren,
    linkEmpty: !hasChildren,
    'header-categories__main-link--new-label': hasChildren && isNew
  })

  return (
    <li className={styles.item}>
      <CategoryLink to={item.url} className={linkClassName}>
        {item.name + ' '}
        {isNew && <span className={styles.label}>New</span>}
      </CategoryLink>
      {hasChildren && <SubLevelMenu items={item.children} />}
    </li>
  )
}

const SubLevelMenu = ({ items }) => {
  let cx = classNames.bind(styles)

  return (
    <div className={styles.dropdownContainer}>
      <ul className={styles.dropdown}>
        {items.map((item, key) => {
          const isTop = item.isTop
          const isBottom = item.isBottom
          const linkClassName = cx(
            { dropdownTop: isTop },
            { dropdownBottom: isBottom }
          )
          return (
            <li className={linkClassName} key={key}>
              <CategoryLink to={item.url}>{item.name + ' '}</CategoryLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const CategoriesMenu = ({ items }) => {
  return (
    <ul className={styles.linksList} data-test-selector="category-menu">
      {items.map((item, key) => <TopLevelMenu key={key} item={item} />)}
    </ul>
  )
}

export default CategoriesMenu
